import { components } from "@/api-schema";
import { DEFAULT_PAGE_SIZE } from "@/common/api/_defaults";
import {
  GroupManualMembershipUserSearchParameters,
  GroupManualMembershipUserSearchRequestBody,
  useGroupManualMembershipUserSearchQuery,
} from "@/common/api/group-manual-membership/use-group-manual-membership-user-search.query";
import { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";
import { TableFeatures } from "@/components/data-table/types";
import { createBasePredefinedTable } from "./_components/base-predefined-table";
import {
  BasePredefinedTableProps,
  DataFetchHooks,
  PredefinedTableConfig,
} from "./_components/base-predefined-table.types";
import { userWithMembershipTableDefaultColumns } from "./user-with-membership-table-columns";

type UserWithMembership = components["schemas"]["UserWithMembershipResponseDto"] & RowWithIdentifier;
type UserWithMembershipQueryParams = GroupManualMembershipUserSearchParameters;
type UserWithMembershipRequestBody = GroupManualMembershipUserSearchRequestBody;

export const USER_WITH_MEMBERSHIP_TABLE_NAME = "user-with-membership-table";

const DEFAULT_COLUMNS = [
  userWithMembershipTableDefaultColumns.columnAvatar,
  userWithMembershipTableDefaultColumns.columnName,
];

const USER_WITH_MEMBERSHIP_TABLE_CONFIG: PredefinedTableConfig<[]> = {
  defaultPageSize: DEFAULT_PAGE_SIZE,
  defaultSorting: [] as const,
  defaultTableConfig: {
    searchPlaceholder: "ram:SearchForUser",
    features: {
      multiSelection: true,
      pagination: true,
      search: true,
      expansion: false,
    } as TableFeatures,
  } as const,
  defaultRowActions: {
    showEdit: false,
    showView: false,
    showDelete: false,
    showRestore: false,
  } as const,
} as const;

const USER_WITH_MEMBERSHIP_TABLE_QUERY_HOOKS: DataFetchHooks<
  UserWithMembership,
  UserWithMembershipQueryParams,
  UserWithMembershipRequestBody
> = {
  useSearchQuery: useGroupManualMembershipUserSearchQuery,
} as const;

const BaseUserWithMembershipTable = createBasePredefinedTable({
  config: USER_WITH_MEMBERSHIP_TABLE_CONFIG,
  queryHooks: USER_WITH_MEMBERSHIP_TABLE_QUERY_HOOKS,
  defaultColumns: DEFAULT_COLUMNS,
});

export interface UserWithMembershipTableProps extends BasePredefinedTableProps<
  UserWithMembership,
  [],
  UserWithMembershipQueryParams,
  UserWithMembershipRequestBody
> {}

export function UserWithMembershipTable(props: UserWithMembershipTableProps) {
  return <BaseUserWithMembershipTable name={USER_WITH_MEMBERSHIP_TABLE_NAME} {...props} />;
}
